import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=3f5e63c3&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e63c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5e63c3')) {
      api.createRecord('3f5e63c3', component.options)
    } else {
      api.reload('3f5e63c3', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=3f5e63c3&scoped=true&", function () {
      api.rerender('3f5e63c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5dtU1ZP57HR/JS/comp/SearchFilterTokens.vue"
export default component.exports